module.exports = __webpack_public_path__ + "8a941b3afef381b364a6df3d58b49d8f.jpg";